/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';

export const useNotificationRelativeDate = (date: Date): [string] => {
  const [value, setValue] = useState<string>('');
  const recalculateValue = useCallback(() => {
    const relative = DateTime.fromJSDate(date).toRelative();
    setValue(relative || '');
  }, [date]);

  useEffect(() => {
    recalculateValue();
    const duration = DateTime.now().diff(DateTime.fromJSDate(date));
    const intervalId = setInterval(recalculateValue, duration.as('seconds') < 60 ? 5000 : 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, [date, recalculateValue]);

  return [value];
};
